






















































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import '../../assets/css/ServiceRequestDetails.scss';
import { ObjectFactory } from '@/config/objectFactory';
import { DateUtils } from '@/util/dateUtils';
import { MathUtils } from '@/util/mathUtils';
import { ApiRequest, CancelRequest } from '@/types/request';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';
import { required } from 'vuelidate/lib/validators';
@Component({
    data() {
        return {
            estimatedCost: '',
            cancelationReason: '',
            reasons: [
                { value: 'R00009', text: 'Appointment Rescheduled' },
                { value: 'R00011', text: 'Incorrect Pick up address provided' },
                { value: 'R00010', text: 'Passenger Provided Own Transportation' },
                { value: 'R00012', text: 'Passenger Refused Transportation' },
                { value: 'R00008', text: 'Passenger Unreachable' },
                { value: 'R00001', text: 'This entry was a test' },
            ],
            comments: '',
        };
    },
     validations: {
        cancelationReason: {
            required,
        },
    },
})
export default class ApproveAuctionModal extends Vue {

    private show = true;
    private id = this.$route.params.id;
    private showConfirmBox = false;
    private showRejectConfirmBox = false;
    private showCancelationReasonModal = false;

    public async mounted() {
        this.getRequestDetails();
    }

    private async getRequestDetails() {
        const response = await ObjectFactory.getRequestService().
        getRequestDetails(this.id, this.$store.state.serverUrl);
        if (response && response.data && response.data.payment && response.data.assignment.auction
            && response.data.assignment.auction.surcharge) {
            this.$data.estimatedCost = MathUtils.
            formatCurrency(response.data.payment.estimatedFare.totalAmount +
            response.data.assignment.auction.surcharge.amount);
        }
    }

     private async approveFare() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
          baseURL: this.$store.state.serverUrl,
          url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${this.id}/approve`,
          loaderEvent: {
              show: true,
          },
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Estimated Fare Approved Successfully..',
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.showConfirmBox = false;
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async cancelRequest(request?: any) {
        const cancelRequest: CancelRequest = {
            reason: this.$data.cancelationReason,
            comments: this.$data.comments,
        };
        const response = await ObjectFactory.getRequestService().cancelRequest(
            request.id, cancelRequest, this.$store.state.serverUrl);
        this.$data.cancelationReason = '';
        this.$data.comments = '';
        this.showCancelationReasonModal = false;
        this.close();
    }

    private close() {
        this.$router.back();
    }
}
